import { colors as muiColors } from '@mui/material'

const teachTeal = {
  25: '#F5FCFD',
  50: '#E2F8FE',
  100: '#B5EDFC',
  200: '#85E1FA',
  300: '#54D5F5',
  400: '#1FC3EB',
  500: '#1FC3EB',
  600: '#19B3D7',
  700: '#0C9EBB',
  // Re-valued for AA (ENG-1320); 900 doubles as hover, replacing the old 850 stop.
  800: '#007387',
  900: '#004D5A',
}

// Teal-green endpoint of the brand progress gradient. Not part of the teal scale
// (it shifts toward green). From the redesign prototype.
const progressGreen = '#008B75'
// Green end of the brand fill gradients behind white text; progressGreen is too light for 4.5:1.
const gradientGreen = '#007A66'

export const colors = {
  ...muiColors,
  tileGreen: {
    main: '#004F3D',
    light: '#E0F2F0',
  },
  tileBlue: {
    main: '#01579B',
    light: '#E1F5FE',
  },
  // One blue for two palette roles: info, and primary.light (the secondary-button and
  // "Your Project" fill). main is the lightest value white text clears 4.5:1 on (ENG-1320).
  infoBlue: {
    main: '#007DBB',
    dark: '#01579B',
  },
  teachTeal,
  progressGreen,
  gradientGreen,
  // Progress-bar fill. The redesign dropped the brand gradient elsewhere but keeps
  // one here deliberately; stops match the redesign prototype.
  progressGradient: `linear-gradient(90deg, ${teachTeal[400]} 0%, ${teachTeal[800]} 55%, ${progressGreen} 100%)`,
  // Grouped so the redesign-specific neutrals stay identifiable as a set.
  redesignNeutral: {
    secondaryText: '#4A5260',
    label: '#5F6B76',
    // Form-field outline; MUI's default 23% black fails the 3:1 boundary minimum (ENG-1320).
    fieldBorder: '#868F98',
    hover: '#E8EAED',
    selected: '#E0F2F0',
    border: '#E4E7EC',
    mutedSurface: '#EEF4F9',
    // A hair darker than white content surfaces so the chrome frame reads as a distinct layer.
    chromeSurface: '#FAFBFC',
  },
  // Content rendered over hero images. The scrim darkens the image so chips and
  // titles stay legible over arbitrary photography.
  heroOverlay: {
    scrim: 'rgba(0, 0, 0, 0.2)',
    scrimHover: 'rgba(0, 0, 0, 0.4)',
    // Home hero only: white caption text passes 4.5:1 over any photo (ENG-1320). Stops are px
    // from the bottom, so the caption sits on the same darkness at every card height.
    captionGradient:
      'linear-gradient(to top, rgba(0, 0, 0, 0.72) 0px, rgba(0, 0, 0, 0.6) 72px, rgba(0, 0, 0, 0.3) 144px, rgba(0, 0, 0, 0) 216px)',
    chipBg: '#002837',
    chipText: '#AAE8F4',
    titleShadow: '0 1px 2px rgba(0, 0, 0, 0.9)',
  },
  // Project type ramps (ENG-1347), exposed as palette.unit / palette.blueprint.
  dustyPlum: {
    main: '#69476B',
    dark: '#4E3552',
    light: '#EFE3F0',
  },
  antiqueGold: {
    main: '#8A6419',
    dark: '#684B12',
    light: '#FBF1DC',
  },
  // Scrim behind the video play button / title (ENG-1121).
  videoOverlay: {
    scrimLight: 'rgba(0, 0, 0, 0.3)',
  },
  // Assessment Map tier cards (ENG-1044). TASK uses dark chipText for AA contrast
  // on its pale fill. Values from REDESIGN_TOKENS.md.
  assessmentTier: {
    PRODUCT: {
      accent: '#004F5E',
      chipBg: '#004F5E',
      chipText: '#FFFFFF',
      background: '#FFFFFF',
      hoverBackground: '#DBEAEC',
    },
    DELIVERABLE: {
      accent: '#3E7E8A',
      chipBg: '#3E7E8A',
      chipText: '#FFFFFF',
      background: '#FFFFFF',
      hoverBackground: '#E1ECEF',
    },
    TASK: {
      accent: '#B8DBE0',
      chipBg: '#B8DBE0',
      chipText: '#003D4A',
      background: '#FFFFFF',
      hoverBackground: '#EAF3F5',
    },
  },
}
